import { DOCUMENT } from '@angular/common';
import { inject, Injector, Provider } from '@angular/core';
import { AFTER_LOGIN_REDIRECT } from './with-authentication';
import { DESKTOP_ONLY_ROLES } from '../rbac/rbac-config';
import { RbacService } from '../rbac/rbac.service';
import {
  injectControlHubDesktopUrl,
  injectControlHubUrl,
} from '@seatix/shared/core';

export function provideCrossAppLoginRedirect(isDesktopApp: boolean): Provider {
  return {
    provide: AFTER_LOGIN_REDIRECT,
    useFactory: () => {
      // Injector breaks the circular chain:
      // AuthStore → AFTER_LOGIN_REDIRECT → RbacService/AuthStore → AuthStore
      const injector = inject(Injector);
      const doc = inject(DOCUMENT);
      const targetUrl = isDesktopApp
        ? injectControlHubUrl()
        : injectControlHubDesktopUrl();

      return () => {
        const primaryRole = injector.get(RbacService).primaryRole();
        if (!primaryRole) return false;

        const isDesktopRole = DESKTOP_ONLY_ROLES.includes(primaryRole);
        const shouldRedirect = isDesktopApp ? !isDesktopRole : isDesktopRole;

        if (!shouldRedirect) return false;

        doc.location.href = targetUrl;
        return true;
      };
    },
  };
}
